// extracted by mini-css-extract-plugin
export default {"captcha":"qZ03U","reset":"V90G1"};